import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import FormRenderer from '../../../lib/FormBuilder/components/FormRenderer';
import api from '../../../api';
import { useSelector } from 'react-redux';
import { profileSelector } from 'redux/user/selectors';
import { ToastsStore } from 'react-toasts';
import { buildRenderSchema } from 'lib/FormBuilder/components/FormBuilder/FormBuilder';

const FormLayout = ({ object, removeSubmit }) => {
    const { _id, form } = object;
    const profile = useSelector(profileSelector);
    const [hasPermission, setHasPermission] = useState(false);
    const [renderElements, setRenderElements] = useState({
        formFields: [],
        validation: {},
        initialValues: {},
        persistentData: false,
        ready: false,
    });

    const submit = (data, setSubmitting, setValues) => {
        const {
            email,
            qsId: qlikId,
            name: username,
            groups: userGroups,
        } = profile;
        api.forms
            .createFormContent(form, { data, username, qlikId, email })
            .then(() => {
                setSubmitting(false);
                ToastsStore.success('Form submitted successfully');
                if (!renderElements.persistentData)
                    setValues(renderElements.initialValues);
            })
            .catch((err) => {
                setSubmitting(false);
                ToastsStore.error('An Error occurred, please try again.');
                console.log(err);
            });
    };

    const preFillData = (_renderElements) => {
        api.forms
            .getLastEntry(form)
            .then((record) => {
                setRenderElements({
                    ..._renderElements,
                    persistentData: true,
                    initialValues: record.data,
                    ready: true,
                });
            })
            .catch((err) => {
                console.log(err);
                setRenderElements({
                    ..._renderElements,
                    ready: true,
                });
            });
    };

    const checkPermission = (formGroups) => {
        const { groups: userGroups } = profile;
        if (userGroups && formGroups) {
            const permission = formGroups.some((i) => userGroups.includes(i));
            setHasPermission(permission);
        }
    };

    const setupForm = (formModel) => {
        const { elements, persistentData, groups } = formModel;
        let _renderElements = {};
        try {
            _renderElements = buildRenderSchema(elements);
        } catch (err) {
            console.error('build render Schema failed', err);
        }
        checkPermission(groups);
        if (elements) {
            if (persistentData) {
                preFillData(_renderElements);
            } else {
                setRenderElements({ ..._renderElements, ready: true });
            }
        }
    };

    const loadForm = () => {
        api.forms
            .get(form)
            .then((result) => {
                setupForm(result);
            })
            .catch((err) => {
                ToastsStore.error('Failed to Load Form');
                console.log(err);
            });
    };

    useEffect(() => {
        if (profile && form) {
            loadForm();
        }
    }, [profile]);

    return (
        <>
            {renderElements.ready && (
                <FormRenderer
                    formFields={renderElements.formFields}
                    validationSchema={renderElements.validation}
                    submit={submit}
                    initialValues={renderElements.initialValues}
                    removeSubmit={!hasPermission}
                />
            )}
        </>
    );
};

export default FormLayout;

FormLayout.propTypes = {
    object: PropTypes.objectOf(PropTypes.any).isRequired,
    removeSubmit: PropTypes.bool,
};

FormLayout.defaultProps = {
    removeSubmit: true,
};
